import { ethers } from 'ethers';

async function signWithProvider(web3Provider) {
  const provider = new ethers.providers.Web3Provider(web3Provider);
  await provider.send('eth_requestAccounts', []);
  const signer = provider.getSigner();
  const address = await signer.getAddress();
  const message = `Sign in to TechProOne\nAddress: ${address}\nTimestamp: ${Date.now()}`;
  const signature = await signer.signMessage(message);
  return { address, signature };
}

// Connect via MetaMask or any injected wallet
export async function connectMetaMask() {
  if (!window.ethereum) {
    throw new Error('No wallet detected. Please install MetaMask or another Web3 wallet.');
  }
  return signWithProvider(window.ethereum);
}

// WalletConnect: available in the roadmap (requires Next.js migration or CRACO setup)
export async function connectWalletConnect() {
  throw new Error('WalletConnect coming soon. Please use MetaMask or log in with email/Google/GitHub.');
}
